export default {
    APP: require('./App.png'),
    Electric: require('./Electric.png'),
    WCA: require('./WCA.png'),
    SHARE: require('./Vector.png'),
    SHARE2: require('./share.png'),
    DOWNLOAD: require('./download.png'),
    SITE_1: require('./sites/SITE_1.png'),
    SITE_2: require('./sites/SITE_2.png'),
    SITE_3: require('./sites/SITE_3.png'),
    SITE_4: require('./sites/SITE_4.png'),
    SITE_5: require('./sites/SITE_5.png'),
    SITE_6: require('./sites/SITE_6.png'),
    SITE_7: require('./sites/SITE_7.png'),
    SITE_8: require('./sites/SITE_8.png'),
    SITE_9: require('./sites/SITE_9.png'),
    SITE_10: require('./sites/SITE_10.png'),
    SITE_11: require('./sites/SITE_11.png'),
    SITE_12: require('./sites/SITE_12.png'),
    SITE_13: require('./sites/SITE_13.png'),
    SITE_14: require('./sites/SITE_14.png'),
    SITE_15: require('./sites/SITE_15.png'),
    SITE_16: require('./sites/SITE_16.png'),
    SITE_17: require('./sites/SITE_17.png'),
    SITE_18: require('./sites/SITE_18.png'),
    SITE_19: require('./sites/SITE_19.png'),
    SITE_20: require('./sites/SITE_20.png'),
    DIST_1: require('./distributers/DIST_1.png'),
    DEFAULT_SITE_ICON: require('./sites/SITE_1.png'),
    USER_TYPE: require('./user_type.png'),
    SELECTED_USER_TYPE: require('./selected_user_type.png'),
    ADMIN: require('./admin.png'),
    ADMIN2: require('./admin2.png'),
    MESSAGING: require('./messaging.png'),
    MESSAGING2: require('./messaging2.png'),
    BILLING: require('./billing.png'),
    BILLING2: require('./billing2.png'),
    HISTORY: require('./history.png'),
    HISTORY2: require('./history2.png'),
    PARKERS: require('./parkers.png'),
    PARKERS2: require('./gmt_header.png'),
    ALLOCATIONS: require('./allocations.png'),
    ALLOCATIONS2: require('./allocations2.png'),
    GMT_HEADER: require('./gmt_header.png'),
    CAR_ITEM: require('./car_item.png'),
    DISACTIVE_ITEM: require('./disactive_item.png'),
    DISACTIVATE_TOKEN: require('./disactivate_token.png'),
    EDIT_ITEM: require('./edit_item.png'),
    TOKEN_ITEM: require('./token_item.png'),
    PARKERS_ITEM: require('./parkers_item.png'),
    DELETE_ITEM: require('./delete_item.png'),
    DELETE_ITEM_2: require('./delete_item_2.png'),
    DELETE_ITEM_3: require('./delete_item_3.png'),
    DELETE_ITEM_4: require('./delete_item_4.png'),
    PHONE: require('./phone.png'),
    EMAIL: require('./email.png'),
    DASHBORAD: require('./dashborad.png'),
    DASHBORAD2: require('./dashborad2.png'),
    TOKEN_OCCUPIED: require('./token_occupied.png'),
    ERROR: require('./error.png'),
    EXTERNAL: require('./external.png'),
    NEW_PARKER: require('./new_parker.png'),
    LEFT_ARROW: require('./left_arrow.png'),
    ADD_BUTTON: require('./add_button.png'),
    ADD_ITEM: require('./add_item.png'),
    CAR: require('./car.png'),
    CAR2: require('./car2.png'),
    USA_FLAG: require('./usa_flag.png'),
    ISRAEL_FLAG: require('./Israel_flag.png'),
    //QUESTION_CIRCLE: require('./question-circle.png'),
    QUESTION_CIRCLE: require('./questionmark_in_circle.png'),
    INFO_CIRCLE: require('./info-circle.png'),
    UPDATE_SUCCESS: require('./update_success.png'),    
    CHECKBOX_CIRCLE: require('./checkbox_circle.png'),
    SEARCH: require('./search.png'),
    EXSISTING_PARKING_ALLOCATION: require('./exsisting_parking_allocation.png'),
    EXISTING_SCOPE: require('./existing_scope.png'),
    SCAN_SUCCESS: require('./scan_success.png'),
    PAYING: require('./paying.png'),
    ADD_PARKING_ALLOCATION: require('./add_parking_allocation.png'),
    PARKING_ALLOCATION: require('./parking_allocation.png'),
    ALLOCATION: require('./allocation.png'),
    ALLOCATION2: require('./allocation2.png'),
    ATTENTION: require('./attention.png'),
    LOGIN_LOGO: require('./login_logo.png'),
    LOGIN_CAR: require('./login_car.png'),
    SIGNUP_CAR: require('./signup_car.png'),
    RESET_PASSWORD_CAR: require('./reset_password_car.png'),
    RESET_PASSWORD_CAR2: require('./reset_password_car2.png'),
    NEW_ENTITY: require('./new_entity.png'),
    WORKSPACE_COFIGURATION: require('./workspace_configuration.png'),
    MY_PROFILE: require('./my_profile.png'),
    LEGAL: require('./legal.png'),
    LOGOUT: require('./logout.png'),
    PERMISSIONS: require('./permissions.png'),
    ADD_ROLE: require('./add_role.png'),
    DISACTIVATE: require('./disactivate.png'),
    ACTIVITY: require('./Activity.png'),
    BILLING_RULE: require('./billing_rule.png'),
    EV_RULE: require('./ev_rule.png'),
    RATE_LIST: require('./rate_list.png'),
    MAILING_LIST: require('./mailing_list.png'),
    QR: require('./qr.png'),
    KIOSK_PIN: require('./kiosk_pin.png'),
    TENANTS: require('./tenants.png'),
    MIXED_USE: require('./mixed_use.png'),
    MINUS: require('./minus.png'),
    PLUS: require('./plus.png'),
    V_MARK: require('./v_mark.png'),
    X_MARK: require('./x_mark.png')
}